const FeesData = {
  adminFee: 150,
  claimsAdminFee: 980,
  additionalDriverFee: 660,
  youngDriverSurcharge: 100,
  fuelDepositRegular: "2 000",
  fuelDepositSUV: "2 500",
  refuelFee: 55,
  eTollAdminFee: "20%",
  babySeat: 650,
  childSeat: 650,
  boosterSeat: 650,
  trafficFineAdminFee: 440,
  extrasDamageLiabilityFee: "3 000",
  tyreAndWindscreenWaiver: 99,
  tyreAndWindscreenWaiverSuper: 99,
  crossBorderFee: 2680,
  mozambiqueFee: 4390,
  oneWayDropOffFee: 600,
  oneWayDropOffFeeBakkies: 2800,
  damageAssessmentFee: 816,
  valetFee: 850,
  afterHoursOffLineFee: 250,
  deliveryAndCollectionIn20km: 575,
  deliveryAndCollectionOutside20km: 23,
  deliveryAndCollectionIn20kmAfterhours: 930,
  deliveryAndCollectionOutside20kmAfterhours: 23,
  overduePenalty: 500,
  noShowPenalty: 600,
  cancellationPenaltyWithin24Hr: 600,
  cancellationPenalty: 300,
  gpsRental: 174,
  bikeRack: 185,
  airportSurcharge: "13%",
  peakSeasonStartDate: '12-07-2026', // MM-DD-YYYY
  peakSeasonEndDate: '01-10-2027', // MM-DD-YYYY
  peakSeasonOnewayFee: 2250
};

export { FeesData };
